module.exports = __webpack_public_path__ + "static/media/twitter.18f76c2e.png";